module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Author"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Ackn"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocfb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Foreword"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s Foreword")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 1")]), _vm._v(" Four Years Prior to Vietnam")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter02"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 2")]), _vm._v(" Arrival in Vietnam")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 3")]), _vm._v(" The Mountains Can Kill You")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 4")]), _vm._v(" Flying in Vietnam: 90 Percent Boredom, 10 Percent Stark Terror")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 5")]), _vm._v(" A ‘Fowl’ed Up Mid-Air Collision")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 6")]), _vm._v(" The Big Splash")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 7")]), _vm._v(" Browning Your Flight Suit")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 8")]), _vm._v(" Holes in my Chopper?")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 9")]), _vm._v(" Christmas in the Philippines")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 10")]), _vm._v(" Scouting in Indian Country")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 11")]), _vm._v(" Happy Hour: TINS Time")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 12")]), _vm._v(" The Stork Flies to Div Arty Air")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 13")]), _vm._v(" Aerobatics on LZ East")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 14")]), _vm._v(" Retreating Blade Stall: One of Many Ways to ‘SCREW THE POOCH’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 15")]), _vm._v(" How Many PACs Can You Stuff in an OH–23G?")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 16")]), _vm._v(" Shaking the Hornets’ Nest")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 17")]), _vm._v(" Saving a Snake-Driver’s Life")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 18")]), _vm._v(" The Rescue")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 19")]), _vm._v(" Midnight Requisitioning")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 20")]), _vm._v(" The ‘A, B, Cs’ of Shooting Down a Loach")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 21")]), _vm._v(" Doc’s Boondoggle")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 22")]), _vm._v(" The Rocket Attack")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 23")]), _vm._v(" How Not to Enter a Helicopter")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 24")]), _vm._v(" Harrowing Day at LZ Professional")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 25")]), _vm._v(" Friendlies on LZ Ross?")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 26")]), _vm._v(" ‘What Are They Going To Do, Send Me To Vietnam?’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 27")]), _vm._v(" The Final Mission")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 28")]), _vm._v(" A Bittersweet Homecoming")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Chapter 29")]), _vm._v(" Epilogue: About the Americal Div Arty Pilots")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Appendix 1")]), _vm._v(" Some Statistics from the Combat Area Casualty File (CACF) as of November 1993")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Endnotes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Endnotes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-147245f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0